import { DateModelOptions } from '../options/date-model-options';
import { TextModelOptions } from '../options/text-model-options';
import { DateModel } from '../primitive/date.model';
import { TextModel } from '../primitive/text.model';
import { CompositeModel } from './composite.model';
import moment from 'moment';

export class ConfirmationComplaintsQcaTextsModel extends CompositeModel {
    public activities: TextModel;
    public allegedTreatment: TextModel;
    public allegedTest: TextModel;
    public damage: TextModel;
    public extentInjury: TextModel;
    public medicalIntervention: TextModel;
    public occurrence: TextModel;
    public otherAccessories: TextModel;
    public personel: TextModel;
    public problem: TextModel;
    public radiationDamage: TextModel;
    public assay: TextModel;
    public medical: TextModel;
    public confidence: TextModel;
    public event: TextModel;
    public occupant: TextModel;
    public procedureDelay: TextModel;
    public medications: TextModel;
    public resultsRepeated: TextModel;
    public resultsUnit: TextModel;
    public clinicalTests: TextModel;
    public treatment: TextModel;
    public catalogNr: TextModel;
    public lotNr: TextModel;
    public expireDate: DateModel;
    public initialResult: TextModel;
    public instrument: TextModel;

    public constructor() {
        super('QcaTexts', {});

        this.activities = <TextModel>(
            this.set(new TextModel('Activities', '', new TextModelOptions({ required: true })))
        );
        this.allegedTreatment = <TextModel>(
            this.set(new TextModel('AllegedTreatment', '', new TextModelOptions({ required: true })))
        );
        this.allegedTest = <TextModel>(
            this.set(new TextModel('AllegedTest', '', new TextModelOptions({ required: true })))
        );
        this.damage = <TextModel>this.set(new TextModel('Damage', '', new TextModelOptions({ required: true })));
        this.extentInjury = <TextModel>(
            this.set(new TextModel('ExtentInjury', '', new TextModelOptions({ required: true })))
        );
        this.medicalIntervention = <TextModel>(
            this.set(new TextModel('MedicalIntervention', '', new TextModelOptions({ required: true })))
        );
        this.occurrence = <TextModel>this.set(new TextModel('Occurence', '', new TextModelOptions({ required: true })));
        this.otherAccessories = <TextModel>(
            this.set(new TextModel('OtherAccessories', '', new TextModelOptions({ required: true })))
        );
        this.personel = <TextModel>this.set(new TextModel('Personel', '', new TextModelOptions({ required: true })));
        this.problem = <TextModel>this.set(new TextModel('Problem', '', new TextModelOptions({ required: true })));
        this.radiationDamage = <TextModel>(
            this.set(new TextModel('RadiationDamage', '', new TextModelOptions({ required: true })))
        );
        this.assay = <TextModel>this.set(new TextModel('Assay', '', new TextModelOptions({ required: true })));
        this.medical = <TextModel>this.set(new TextModel('Medical', '', new TextModelOptions({ required: true })));
        this.confidence = <TextModel>(
            this.set(new TextModel('Confidence', '', new TextModelOptions({ required: true })))
        );
        this.event = <TextModel>this.set(new TextModel('Event', '', new TextModelOptions({ required: true })));
        this.occupant = <TextModel>this.set(new TextModel('Occupant', '', new TextModelOptions({ required: true })));
        this.procedureDelay = <TextModel>(
            this.set(new TextModel('ProcedureDelay', '', new TextModelOptions({ required: true })))
        );
        this.medications = <TextModel>(
            this.set(new TextModel('Medications', '', new TextModelOptions({ required: true })))
        );
        this.resultsRepeated = <TextModel>(
            this.set(new TextModel('ResultsRepeated', '', new TextModelOptions({ required: true })))
        );
        this.resultsUnit = <TextModel>(
            this.set(new TextModel('ResultsUnit', '', new TextModelOptions({ required: true })))
        );
        this.clinicalTests = <TextModel>(
            this.set(new TextModel('ClinicalTests', '', new TextModelOptions({ required: true })))
        );
        this.treatment = <TextModel>this.set(new TextModel('Treatment', '', new TextModelOptions({ required: true })));
        this.catalogNr = <TextModel>this.set(new TextModel('Catalog', '', new TextModelOptions({ required: true })));
        this.lotNr = <TextModel>this.set(new TextModel('Lot', '', new TextModelOptions({ required: true })));
        this.expireDate = <DateModel>(
            this.set(new DateModel('Expired', undefined, new DateModelOptions({ required: true })))
        );
        this.initialResult = <TextModel>(
            this.set(new TextModel('InitResult', '', new TextModelOptions({ required: true })))
        );
        this.instrument = <TextModel>(
            this.set(new TextModel('Instrument', '', new TextModelOptions({ required: true })))
        );
    }

    public toJSON(): JsonConfirmationComplaintsQcaTextsModel {
        return {
            activities: this.activities.value,
            allegedTreatment: this.allegedTreatment.value,
            allegedTest: this.allegedTest.value,
            damage: this.damage.value,
            extentInjury: this.extentInjury.value,
            medicalIntervention: this.medicalIntervention.value,
            occurrence: this.occurrence.value,
            otherAccessories: this.otherAccessories.value,
            personel: this.personel.value,
            problem: this.problem.value,
            radiationDamage: this.radiationDamage.value,
            assay: this.assay.value,
            medical: this.medical.value,
            confidence: this.confidence.value,
            event: this.event.value,
            occupant: this.occupant.value,
            procedureDelay: this.procedureDelay.value,
            medications: this.medications.value,
            resultsRepeated: this.resultsRepeated.value,
            resultsUnit: this.resultsUnit.value,
            clinicalTests: this.clinicalTests.value,
            treatment: this.treatment.value,
            catalogNr: this.catalogNr.value,
            lotNr: this.lotNr.value,
            expireDate: this.expireDate.value.toISOString(),
            initialResult: this.initialResult.value,
            instrument: this.instrument.value,
        };
    }
}

export class ConfirmationComplaintsQcaTextsModelFromJson extends ConfirmationComplaintsQcaTextsModel {
    public constructor(data: JsonConfirmationComplaintsQcaTextsModel) {
        super();
        this.activities.value = data.activities;
        this.allegedTreatment.value = data.allegedTreatment;
        this.allegedTest.value = data.allegedTest;
        this.damage.value = data.damage;
        this.extentInjury.value = data.extentInjury;
        this.medicalIntervention.value = data.medicalIntervention;
        this.occurrence.value = data.occurrence;
        this.otherAccessories.value = data.otherAccessories;
        this.personel.value = data.personel;
        this.problem.value = data.problem;
        this.radiationDamage.value = data.radiationDamage;
        this.assay.value = data.assay;
        this.medical.value = data.medical;
        this.confidence.value = data.confidence;
        this.event.value = data.event;
        this.occupant.value = data.occupant;
        this.procedureDelay.value = data.procedureDelay;
        this.medications.value = data.medications;
        this.resultsRepeated.value = data.resultsRepeated;
        this.resultsUnit.value = data.resultsUnit;
        this.clinicalTests.value = data.clinicalTests;
        this.treatment.value = data.treatment;
        this.catalogNr.value = data.catalogNr;
        this.lotNr.value = data.lotNr;
        this.expireDate.value = moment(data.expireDate);
        this.initialResult.value = data.initialResult;
        this.instrument.value = data.instrument;
    }
}

export interface JsonConfirmationComplaintsQcaTextsModel {
    activities: string;
    allegedTreatment: string;
    allegedTest: string;
    damage: string;
    extentInjury: string;
    medicalIntervention: string;
    occurrence: string;
    otherAccessories: string;
    personel: string;
    problem: string;
    radiationDamage: string;
    assay: string;
    medical: string;
    confidence: string;
    event: string;
    occupant: string;
    procedureDelay: string;
    medications: string;
    resultsRepeated: string;
    resultsUnit: string;
    clinicalTests: string;
    treatment: string;
    catalogNr: string;
    lotNr: string;
    expireDate: string;
    initialResult: string;
    instrument: string;
}
